<script setup lang="ts">
import type { HeroItem } from 'types/blocks';

defineProps<{
  data: HeroItem[];
}>();
</script>

<template>
  <div class="bg-black/50">
    <template v-if="data?.length === 1">
      <BaseHeroItem
        v-if="data[0]?.content"
        :data="data[0].content"
      />
    </template>

    <BaseSlider
      v-else-if="data?.length > 1"
      :disable-progress="true"
      :slider-options="{ live: false }"
    >
      <BaseSliderItem
        v-for="(item, index) in data"
        :key="`item-${index}`"
      >
        <BaseHeroItem :data="item.content" />
      </BaseSliderItem>
    </BaseSlider>
  </div>
</template>
